import styled from 'styled-components';

const Container = styled.div`
  width: 100%;
  margin-right: auto;
  margin-left: auto;
  box-sizing: border-box;
  @media (min-width: ${({ theme: { breakpoints } }) => breakpoints[0]}) {
    max-width: ${(props) => (props.fluid ? '100%' : '540px')};
    box-sizing: border-box;
    padding: 0px 15px;
  };
  @media (min-width: ${({ theme: { breakpoints } }) => breakpoints[1]}) {
    max-width: ${(props) => (props.fluid ? '100%' : '720px')};
    padding: 0px;
  };
  @media (min-width: ${({ theme: { breakpoints } }) => breakpoints[2]}) {
    max-width: ${(props) => (props.fluid ? '100%' : '960px')};
    padding: 0px;
  };
  @media (min-width: ${({ theme: { breakpoints } }) => breakpoints[3]}) {
    max-width: ${(props) => (props.fluid ? '100%' : '1140px')};
    padding: 0px;
  };
  @media (min-width: ${({ theme: { breakpoints } }) => breakpoints[4]}) {
    max-width: ${(props) => (props.fluid ? '100%' : '1420px')};
    padding: 0px;
  };
`;

export default Container;



// WEBPACK FOOTER //
// client/components/Container/index.js